import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, DefaultUrlSerializer } from "@angular/router";
import { CocService } from "../../coc.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { StatesPetitionsService } from "src/app/core/services/states-petitions.service";
import { CommonService } from "src/app/core/services/common.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { AppConstants } from "src/app/constants/app.constants";
import { dynamicsFields } from "../../models/dynamicsFields";
import { TranslateService } from "@ngx-translate/core";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { RoutingStatesService } from "src/app/core/services/routingStates.service";
import { DynamicFieldsComponent } from "src/app/shared/dynamic-fields/dynamic-fields.component";
import { CorrectCoC, FileCorrect } from "../../models/correctCoC";
import { ListRelatedRequests } from "src/app/shared/models/listRelatedRequest";
import { RoutingStates } from "src/app/core/models/routingStates";
import { TableConstants } from "src/app/constants/tableConstants";
import { CommentsHistoryPeticionComponent } from "src/app/shared/comments-history-peticion/comments-history-peticion.component";
import {
  FieldBase,
  InputTextField,
  ShowField,
  TextareaField,
} from "src/app/shared/form-fields/model";
import * as moment from "moment";
import { FormFieldsComponent } from "src/app/shared/form-fields/form-fields.component";
import { Validators } from "@angular/forms";

@Component({
  selector: "app-detail-mailbox",
  templateUrl: "./detail-mailbox.component.html",
  styleUrls: ["./detail-mailbox.component.scss"],
})
export class DetailMailboxComponent implements OnInit {
  @ViewChild("dynamicFields") dynamicFields: DynamicFieldsComponent;
  @ViewChild(CommentsHistoryPeticionComponent)
  commentsHistory: CommentsHistoryPeticionComponent;

  @ViewChild("vehiculo") vehiculoFields: FormFieldsComponent;
  @ViewChild("solicitud") solicitudFields: FormFieldsComponent;
  @ViewChild("comentario") comentarioFields: FormFieldsComponent;

  public fieldsSolicitud: FieldBase<any>[];
  public fieldsVehiculo: FieldBase<any>[];
  public fieldsComentario: FieldBase<any>[];

  coc;
  cocLoaded: boolean = false;
  fields: dynamicsFields[];
  id;
  type: string;
  routing = RoutingConstants.cocMailBox;
  operation: string;
  userIdConected: string;
  castDynamicsFields = AppConstants.castDynamicsFields;
  roles = AppConstants.roles;
  isAnalystAnalystBasicAndAdvan: boolean = false;
  fileNameForCorrect: string;
  peComentariosNuevo: string;
  listCoCBastidores;

  sectionHidden = {
    peticion: false,
    vehiculo: false,
    concreto: false,
    obs: false,
  };

  config: ListRelatedRequests;
  routingStates: RoutingStates;

  constructor(
    private cocService: CocService,
    private toastrAlertService: ToastrAlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private listValueService: ListValueService,
    private tokenService: TokenService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private statesPetitionsService: StatesPetitionsService,
    private sweetAlertService: SweetAlertService,
    private routingStatesService: RoutingStatesService
  ) {
    this.userIdConected = this.tokenService.getUserName();
    this.isAnalystAnalystBasicAndAdvan =
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO);
    this.config = {
      type: "COC",
      bastidor: "",
      title: "Más CoC",
      opened: false,
      tableContasts: TableConstants.cocQuery,
      optionsTable:
        TableConstants.NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel,
      routingTableEnTramite: RoutingConstants.cocQuery,
      routingTableHistory: RoutingConstants.cocQueryHistory,
    };
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((data) => {
      this.init();
    });
  }

  init() {
    this.routingStates = this.routingStatesService.getRoutingStates();
    this.id = this.activatedRoute.snapshot.params.id;
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.type = this.activatedRoute.data["_value"]["type"];
    if (this.type == "history") {
      this.getCoCHistory();
    } else if (this.type == "NotHistory") {
      this.getCoCQuery();
    } else {
      this.getCoC();
    }
  }

  getCoC() {
    this.cocService.getCoc(this.id).subscribe(
      (data) => {
        this.setInfo(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCoCQuery() {
    this.cocService.getCoCQuery(this.id).subscribe(
      (data) => {
        this.setInfo(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCoCHistory() {
    this.cocService.getCoCQueryHistory(this.id).subscribe(
      (data) => {
        this.setInfo(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  setInfo(data) {
    this.cocLoaded = true;
    this.fields = this.commonService.castingDynamicFields(
      this.castDynamicsFields,
      data.detallepeticiones
    );
    this.filtraMarcasVehiculosSegunRegionDelConcesionarioDelUsuario();
    this.config.bastidor = data.peBastidor;
    this.coc = data;
    this.getFechaPrimeraMatricula();
    if (this.coc.peTcertificado == "CM" || this.coc.peTcertificado == "CML") {
      this.getBastidoresMasivo();
    }
    if (this.coc.peTcertificado == "CC") {
      let field = this.fields.find(
        (e) => e.dpCampo == "Fichero excel de bastidores"
      );
      field.dpCampo = "Documentación";
    }
    this.initFields();
    setTimeout(() => {
            this.solicitudFields.initFormWithData(this.fieldsSolicitud);
          });
    
  }

  getBastidoresMasivo() {
    if (this.type == "history") {
      this.listValueService
        .listHBastidoresCOC(this.id, this.coc.peRelease)
        .subscribe(
          (data) => {
            this.listCoCBastidores = data;
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    } else {
      this.listValueService
        .listBastidoresCOC(this.id, this.coc.peRelease)
        .subscribe(
          (data) => {
            this.listCoCBastidores = data;
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  getFechaPrimeraMatricula() {
    if (this.coc.peTcertificado !== "CM" && this.coc.peTcertificado !== "CML") {
      this.fields.forEach((e) => {
        if (e.dpCampo == "paramDetallePeticionFecPriMat") {
          this.coc["paramDetallePeticionFecPriMat"] = e.dpValor;
        }
      });
    }
  }

  goList() {
    if (this.routingStates) {
      this.router.navigate([
        this.routingStates.urlBefore,
        this.routingStates.urlBeforeId,
      ]);
    } else if (this.activatedRoute.data["_value"]["url"] == "consulta") {
      this.router.navigate([RoutingConstants.cocQuery.list]);
    } else {
      this.router.navigate([this.routing.list]);
    }
  }

  reloadDetail(state: string) {
    this.cocLoaded = false;
    this.commentsHistory.commentsHistory.loaded = false;
    if (state == "FG" || state == "EF") {
      this.router.navigate([
        RoutingConstants.cocQueryHistory.edit,
        this.coc.peId,
      ]);
    } else if (state == "RE" || state == "PF" || state == "FI") {
      if (this.router.url.startsWith(RoutingConstants.cocQuery.edit)) {
        this.router.navigate([RoutingConstants.cocQuery.list]);
      } else {
        this.router.navigate([RoutingConstants.cocMailBox.list]);
      }
    } else if (state == "PA") {
      this.router.navigate([RoutingConstants.cocQuery.edit, this.coc.peId]);
    } else {
      if (this.type != "history" && this.type != "NotHistory") {
        this.init();
      }
      if ((this.type = "NotHistory")) {
        this.init();
      } else {
        this.router.navigate([RoutingConstants.cocQuery.edit, this.coc.peId]);
      }
    }
  }
  reasgine(value: string) {
    this.init();
  }

  goEdit() {
    this.fileNameForCorrect = this.fields.find(
      (e) => e.camposdisponibles.cdTipo == "FILE"
    )?.dpFichero;
    this.operation = "edit";
    this.initFields();
  }

  goDetail(type?: string) {
    let index = this.fields.findIndex(
      (e) => e.camposdisponibles.cdTipo == "FILE"
    );
    if (index > -1) {
      this.fields[index].dpFichero = this.fileNameForCorrect;
    }
    this.operation = "detail";
    this.initFields();
  }

  onSave() {
    let dynamicFields = this.formatDynamicFields();
    if (!dynamicFields || dynamicFields.length == 0) {
      let message = this.translateService.instant("messages.allfieldsRequired");
      this.toastrAlertService.toastrFail(message);
    } else {
      if (this.coc.peTcertificado == "CM" || this.coc.peTcertificado == "CML") {
        return this.onSaveCMorCML(dynamicFields);
      }
      let formComentario = this.comentarioFields.getForm();
      let formVehiculo = this.vehiculoFields.getForm();
      if (formVehiculo && formComentario) {
        let files: FileCorrect[] = null;
        if (this.dynamicFields.files && this.dynamicFields.files.length > 0) {
          files = this.dynamicFields.files;
        }
        let correctCoCDto: CorrectCoC = {
          peId: this.coc.peId,
          peComentarios: formComentario.value.nuevoComentario,
          peRelease: this.coc.peRelease,
          peMatricula: "",
          peTCertificado: this.coc.peTcertificado,
          peBastidor: formVehiculo.value.bastidor,
          files: null,
          detallepeticiones: [...dynamicFields, ...this.getOthersFields()],
        };
        this.sweetAlertService.sweetAlertLoading();
        this.commentsHistory.commentsHistory.loaded = false;
        this.cocService
          .correctCoC(files, correctCoCDto, this.coc.peTcertificado)
          .subscribe(
            (data) => {
              this.toastrAlertService.toastrSuccess(data.mensaje);
              this.sweetAlertService.sweetAlertClose();
              this.cocLoaded = false;
              this.ngOnInit();
            },
            (err) => {
              this.sweetAlertService.sweetAlertClose();
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      }
    }
  }

  onSaveCMorCML(dynamicFields: dynamicsFields[]) {
    let formComentario = this.comentarioFields.getForm();
    if (formComentario) {
      let files: FileCorrect[] = null;
      if (this.dynamicFields.files && this.dynamicFields.files.length > 0) {
        files = this.dynamicFields.files;
      }
      let correctCoCDto: CorrectCoC = {
        peId: this.coc.peId,
        peComentarios: formComentario.value.nuevoComentario,
        peRelease: this.coc.peRelease,
        peMatricula: "",
        peTCertificado: this.coc.peTcertificado,
        peBastidor: this.coc.peBastidor,
        files: null,
        detallepeticiones: [...dynamicFields, ...this.getOthersFields()],
      };
      this.sweetAlertService.sweetAlertLoading();
      this.commentsHistory.commentsHistory.loaded = false;
      this.cocService
        .correctCoC(files, correctCoCDto, this.coc.peTcertificado)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(data.mensaje);
            this.sweetAlertService.sweetAlertClose();
            this.cocLoaded = false;
            this.ngOnInit();
          },
          (err) => {
            this.sweetAlertService.sweetAlertClose();
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  private formatDynamicFields(): dynamicsFields[] {
    let fields: dynamicsFields[] = [];
    let anyFieldEmpty: boolean = false;
    this.dynamicFields.fields.forEach((e) => {
      if (e.camposdisponibles.cdTipo == "STATICLIST") {
        e.camposdisponibles.cdListadb = null;
      }
      let object: dynamicsFields = {
        camposdisponibles: e.camposdisponibles,
        dpCampo: e.dpCampoid,
        dpCampoid: null,
        dpDocumentacion: null,
        dpFichero: e.dpFichero,
        dpId: e.dpId,
        dpRelease: e.dpRelease,
        dpValor:
          e.camposdisponibles.cdTipo == "STATICLIST" &&
          e.dpValor &&
          e.dpValor.valor
            ? e.dpValor.valor
            : e.dpValor,
      };
      if (
        (e.dpValor && e.camposdisponibles.cdTipo != "STATICLIST") ||
        (e.dpValor &&
          (e.dpValor.valor || e.dpValor == "SEAT" || e.dpValor == "VOLKS")) ||
        e.dpFichero
      ) {
        fields.push(object);
      } else {
        anyFieldEmpty = true;
      }
    });
    return anyFieldEmpty ? [] : fields;
  }

  private getOthersFields(): dynamicsFields[] {
    let resultArray: dynamicsFields[] = [];
    this.coc.detallepeticiones.forEach((e) => {
      let pos: number = this.castDynamicsFields.findIndex(
        (element) => element.id == e.dpCampo
      );
      if (pos == -1) {
        let object: dynamicsFields = {
          camposdisponibles: null,
          dpCampo: e.dpCampo,
          dpCampoid: e.dpCampoid,
          dpDocumentacion: e?.dpDocumentacion,
          dpFichero: e.dpFichero,
          dpId: e.dpId,
          dpRelease: e.dpRelease,
          dpValor: e.dpValor,
        };
        resultArray.push(object);
      }
    });

    return resultArray;
  }

  downloadFile(field: any) {
    this.sweetAlertService.sweetAlertLoading();
    let object = this.castDynamicsFields.find((e) => e.id == field.dpCampoid);
    this.commonService
      .getFilesOfDetallePeticiones(
        object.id,
        field.dpId,
        field.dpRelease,
        this.type == "history" ? "true" : "false"
      )
      .subscribe(
        (data) => {
          this.commonService.downloadFile(data, field.dpFichero);
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  public isRHomologOrRevi(): boolean {
    if (
      this.tokenService.hasRole(this.roles.RHOMOLOG) ||
      this.tokenService.hasRole(this.roles.REVISOR)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalist(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalistNoBasic(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }
  
  public isAdmin(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ADMIN)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalistaTramitante(): boolean {
    return this.userIdConected === this.coc.analistaId;
  }

  public isPrecioEdit(): boolean
  {
    return (this.operation == 'detail' && this.coc && (this.coc.peEstado == 'PA' || (this.coc.peEstado == 'AN' && this.isAnalistaTramitante())) && this.isAnalistNoBasic());
  }

  onSavePrecio()
  {
    if(this.solicitudFields.getForm() != null)
    {
      let nuevoPrecio = this.solicitudFields.getForm().value.precio;
      nuevoPrecio = nuevoPrecio.replace(/[,]/g, ".");
      
      this.sweetAlertService.sweetAlertLoading();
      this.cocService
          .editarPrecio(this.coc.peId, nuevoPrecio)
          .subscribe(
            (data) => {
              this.sweetAlertService.sweetAlertClose();
              this.toastrAlertService.toastrSuccess(data.mensaje);
              this.ngOnInit();
            },
            (err) => {
              this.sweetAlertService.sweetAlertClose();
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
    }
  }

  private initFields(): void {
    this.fieldsSolicitud = [
      new ShowField({
        label: "ID",
        value: this.coc.peId,
      }),
      new ShowField({
        label: "Tipo certificado",
        value: this.coc.peTcertificado,
      }),
      new ShowField({
        label: "Fecha solicitud",
        value: this.coc.peCreacion
          ? moment(this.coc.peCreacion).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Hora solicitud",
        value: this.coc.peCreacion
          ? moment(this.coc.peCreacion).format("HH:mm:ss")
          : "",
      }),
      new ShowField({
        label: "Concesionario",
        value: this.coc.peCpeticionario,
      }),
      new ShowField({
        label: "Usuario",
        value:
          this.coc?.usId +
          " - " +
          this.coc?.usNombre +
          " " +
          (this.coc?.usApellido1 ? this.coc?.usApellido1 : "") +
          " " +
          (this.coc?.usApellido2 ? this.coc?.usApellido2 : ""),
      }),
      new ShowField({
        label: "Teléfono",
        value: this.coc?.usTelefono,
      }),
      new ShowField({
        label: "Estado",
        value: this.coc?.peEstado,
      }),
      new ShowField({
        label: "Fecha tramitación",
        value: this.coc.peEntrega
          ? moment(this.coc.peEntrega).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Fecha facturación",
        value: this.coc.peFactura
          ? moment(this.coc.peFactura).format("DD/MM/yyyy")
          : "",
      }),
    ];
    if (this.isRHomologOrRevi() || this.isAnalistNoBasic() || this.isAdmin()) 
    {
      if (/^\d+\.\d$/.test(this.coc.pePrecio)) 
      {
        this.coc.pePrecio += '0';
      }
      let precio: string = "" + this.coc.pePrecio;
      precio = precio.replace(/\./g, ",");
      this.fieldsSolicitud.push(
        new InputTextField({
          label: "Precio (€)",
          value: precio,
          formControlName: "precio",
          required: true,
          onlyShow: !((this.coc?.peEstado == "PA" || (this.coc?.peEstado == "AN" && this.isAnalistaTramitante())) && this.isAnalistNoBasic()),
          validators: [Validators.pattern(/^[0-9]{1,5}([,][0-9]{1,2})?$/)]
        }),
      );
    }
    this.fieldsVehiculo = [
      new InputTextField({
        label: "Número de bastidor",
        value: this.coc.peBastidor,
        formControlName: "bastidor",
        onlyShow: this.operation != "edit",
        required: true,
      }),
    ];

    if (this.operation == "edit") {
      this.fieldsComentario = [
        new ShowField({
          label: "Último comentario",
          value: this.coc.peComentarios,
          style: { "min-height": "50px" },
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { "min-height": "100px" },
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.coc.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    } else {
      this.fieldsComentario = [
        new TextareaField({
          label: "Comentario",
          value: this.coc.peComentarios,
          formControlName: "comentario",
          style: { "min-height": "50px" },
          onlyShow: true,
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { height: "100px" },
          hide: true,
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.coc.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    }
  }

  private filtraMarcasVehiculosSegunRegionDelConcesionarioDelUsuario() {
    let fieldMarca: any = this.fields.find(
      (field) => field.dpCampoid == "paramDetallePeticionMarca"
    );
    if (fieldMarca == null || fieldMarca.camposdisponibles.cdListadb == null)
      return;
    if (this.soloPuedeElegirSeat()) {
      fieldMarca.camposdisponibles.cdListadb =
        fieldMarca.camposdisponibles.cdListadb.filter(
          (marca) => marca.valor == "SEAT"
        );
    } else if (this.soloPuedeElegirVolkswagen()) {
      fieldMarca.camposdisponibles.cdListadb =
        fieldMarca.camposdisponibles.cdListadb.filter(
          (marca) => marca.valor == "VOLKS"
        );
    }
  }

  private soloPuedeElegirSeat() {
    if (!this.tokenService.hasRole(AppConstants.roles.CONCES)) return false;
    return this.tokenService.getRegionDelConcesionario() == "SEAT";
  }

  private soloPuedeElegirVolkswagen() {
    if (!this.tokenService.hasRole(AppConstants.roles.CONCES)) return false;
    return this.tokenService.getRegionDelConcesionario() == "VOLKSWAGEN";
  }
}
